/**
 * Validation messages
 */

// Define validation messages with uppercase and underscores for keys
export const VALIDATION_MESSAGES = {
  START_DATE: {
    INVALID: '開始日を日付形式(yyyy/MM/dd)で入力してください',
    MIN: '開始日は{minDate}より後に設定してください',
    REQUIRED: '開始日を入力してください',
    MIN_VALUE: '開始日は申込日より後に設定してください',
    MIN_CURRENT_TIME: '開始日は現在日より後に設定してください',
  },
  END_DATE: {
    INVALID: '終了日を日付形式(yyyy/MM/dd)で入力してください',
    REQUIRED: '終了日を入力してください',
    MIN_VALUE: '終了日は開始日より後に設定してください',
  },
  COMMON: {
    MAX_LENGTH: (attribute: string, max: number): string =>
      `${attribute}は${max}文字以下のみ有効です`,
    MAX_LENGTH_SYSTEM: (max: number): string => `${max}文字以下で入力してください`,
  },
  NAME: {
    REQUIRED: '会社名は必須です',
  },
  SYSTEM: {
    NAME: {
      TEXT: 'システム名',
      REQUIRED: 'システム名を入力してください',
    },
    POSITION: {
      INVALID: '整数を半角数字で入力してください',
      REQUIRED: '表示順を入力してください',
      RANGE: '表示順は[1〜${0}]の範囲内で入力してください',
    },
    DESCRIPTION: {
      TEXT: 'システム説明文',
      REQUIRED: 'システム説明文を入力してください',
    },
    URL: {
      TEXT: 'システムURL',
      REQUIRED: 'システムURLを入力してください',
      FORMAT: 'http:// または https://  から始まる URL を入力してください',
    },
    COLOR: {
      TEXT: 'カラーコード',
      REQUIRED: 'カラーコードを入力してください',
      INVALID: '入力したカラーコードは存在しません。有効なカラーコードを入力してください',
    },
    ICON: {
      MAX_SIZE: '1MBまでアップロードできます',
      EXTENSION: 'JPEG、PNGファイルをアップロードしてください',
      REQUIRED: 'ファイルをアップロードしてください',
    },
  },
};

// Define success and error messages
export const NOTIFICATION_MESSAGES = {
  ERROR: {
    DOWNLOAD: 'ダウンロードが失敗しました。再度お試しください。',
    DELETE: '削除失敗',
    SEARCH: '該当するデータがありません',
    UPDATE: '変更内容の保存に失敗しました',
    UPLOAD: 'ファイルアップロード失敗',
    UPDATE_APPROVED: '承認失敗',
    UPDATE_DISAPPROVED: '非承認失敗',
  },
  SUCCESS: {
    DELETE: '削除成功',
    UPDATE: '変更内容を保存しました',
    UPLOAD: 'ファイルアップロード成功',
    UPDATE_APPROVED: '承認成功',
    UPDATE_DISAPPROVED: '非承認成功',
  },
  QUESTION: {
    APPROVE: '選択した申込を承認して宜しいですか？',
    DISAPPROVED: '選択した申込を非承認して宜しいですか？',
  },
};
